'use strict';

const isMedium = require('../utils/isMedium');

$(() => {
	// Overlay full-page: aggiungi classe da data-has-background (opzionale)
	$('.dd[data-has-background]').addClass('dd--has-background');

	function closeDd($dd) {
		$dd.removeClass('is-open');
		$dd.find('.dd__toggle').attr('aria-expanded', 'false');
	}

	function openDd($dd) {
		closeDd($('.dd.is-open').not($dd));
		$dd.addClass('is-open');
		$dd.find('.dd__toggle').attr('aria-expanded', 'true');
	}

	/**
	 * Shared toggle used by pointer and keyboard. Fires `lavazza:ddAfterToggle` on the toggle so
	 * menu.js can sync mobile full-screen layout without duplicating open/close logic.
	 * `<button class="dd__toggle">` gets Enter/Space → native click; `<a class="dd__toggle">`
	 * needs explicit keydown or Enter would follow href.
	 */
	function applyDdToggle($toggle) {
		const $dd = $toggle.closest('.dd');
		if ($dd.hasClass('is-open')) {
			closeDd($dd);
		} else {
			openDd($dd);
		}
		$toggle.trigger('lavazza:ddAfterToggle');
	}

	// Click trigger
	$(document).on('click', '.dd:not(.dd--hover):not(.product__pack-select-dd--static) .dd__toggle', function onDdToggleClick(e) {
		if ($(this).attr('data-menu-toggle') === 'true') {
			e.preventDefault();
		}
		e.stopPropagation();
		applyDdToggle($(this));
	});

	// Keyboard: Enter / Space on anchor toggles (L1 mega menu). Skip <button> toggles — UA fires click.
	// Skip <a href="…"> leaf links — Enter must navigate.
	$(document).on('keydown', '.dd:not(.dd--hover):not(.product__pack-select-dd--static) .dd__toggle', function onDdToggleKeydown(e) {
		if (e.key !== 'Enter' && e.key !== ' ') {
			return;
		}
		if (this.tagName.toLowerCase() === 'button') {
			return;
		}
		if ($(this).attr('data-menu-toggle') === 'true') {
			e.preventDefault();
			e.stopPropagation();
			applyDdToggle($(this));
			return;
		}
		const href = this.getAttribute('href');
		if (href && href !== '#' && !href.trim().startsWith('javascript:')) {
			return;
		}
		e.preventDefault();
		e.stopPropagation();
		applyDdToggle($(this));
	});

	// Close when clicking outside. Clicks inside any `.dd` must be ignored: other `document` handlers
	// still run after the toggle handler, and `stopPropagation` on the button does not stop them.
	$(document).on('click', e => {
		if ($(e.target).closest('.dd').length) {
			return;
		}
		closeDd($('.dd.is-open'));
	});

	$(document).on('click', '.dd.is-open .dd__background-overlay-menu', function onOverlayClick(e) {
		if (e.target !== this || !isMedium()) {
			return;
		}
		closeDd($(this).closest('.dd'));
	});

	$(document).on('click', '.dd', e => {
		e.stopPropagation();
	});

	// Hover trigger
	$(document)
		.on('mouseenter', '.dd--hover', function onDdHoverEnter() {
			openDd($(this));
		})
		.on('mouseleave', '.dd--hover', function onDdHoverLeave() {
			closeDd($(this));
		});

	$(document)
		.on('mouseenter', '.dd-md--hover', function onDdMdHoverEnter() {
			if (!isMedium()) return;
			openDd($(this));
		})
		.on('mouseleave', '.dd-md--hover', function onDdMdHoverLeave() {
			if (!isMedium()) return;
			closeDd($(this));
		});

	// Close dropdown when clicking on an item
	$(document).on('click', '.dd .dd__item', function onDdItemClick() {
		closeDd($(this).closest('.dd'));
	});

	// Escape
	$(document).on('keydown', '.dd:not(.product__pack-select-dd--static)', function onDdKeydown(e) {
		if (e.key === 'Escape') {
			const $dd = $(this);
			closeDd($dd);
			$dd.find('.dd__toggle').focus();
		}
	});

	// Accessibility arrows — pack select owns its own option keyboard handling.
	$(document).on('keydown', '.dd:not(.product__pack-select-dd--static):not([data-pack-select]) .dd__item', function onDdItemKeydown(e) {
		if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
		e.preventDefault();
		const $items = $(this).closest('.dd__menu').find('.dd__item');
		const idx = $items.index(this);
		$items.eq(e.key === 'ArrowDown' ? idx + 1 : idx - 1).focus();
	});
});
